import { render } from "./not_found.vue?vue&type=template&id=5a8df7d4&scoped=true"
import script from "./not_found.vue?vue&type=script&lang=js"
export * from "./not_found.vue?vue&type=script&lang=js"

import "./not_found.vue?vue&type=style&index=0&id=5a8df7d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8df7d4"]])

export default __exports__